<template>
      <a-form>
        <a-form-item label="送积分" required>
              <a-input-number v-model:value="point" @change="onchange" style="width:300px" :precision="0"></a-input-number>
        </a-form-item>
      </a-form>
</template>

<script>
import { onMounted, ref, watch } from 'vue'
export default {
  name:'isPoint',
  props:{
    point_num:Number
  },
  setup(props,{emit}){  
      const point=ref('')
      const onchange=(e)=>{
        emit('update:value',e)
      }
        onMounted(()=>{
        if(props.point_num){
          point.value=props.point_num
        }
      })
      return{
        point,
        onchange
      }
  }
}
</script>